import * as actionTypes from "../types";
import axiosInstance from "../../config/AxiosConfig";
import { post } from "../../config/Requests";
import { removeToken, storeToken, setOperator, removeOperator, getToken } from './../../config/storageData';
import moment from "moment-timezone";

export const authSucceed = (token, operator) => {
	storeToken(token);
	setOperator(operator);

	return {
		type: actionTypes.AUTH_SUCCEEDED,
		token: token,
		operator: operator
	};
};

export const logout = () => {
	removeToken();
	removeOperator();

	return dispatch => {
		dispatch({
			type: actionTypes.LOGOUT
		});
	};
};

export const auth = (email, username, password) => {
	return dispatch => {
		post(
			dispatch,
			"kalendarz/logowanie.php",
			{
				uzytkownik: email,
				haslo: password,
				login: username
			},
			(response) => dispatch(authSucceed(response.data.data.token, response.data.data.operator)),
			() => dispatch({ type: actionTypes.AUTH_FAILED })
		);
	};
};

export const forgotPassword = (username, login, email) => {
	return dispatch => {
		post(
			dispatch,
			"kalendarz/reset_hasla.php",
			{
				uzytkownik: username,
				login: login,
				email: email
			},
			response => console.log('response', response)
		)
	};
};

export const checkToken = () => {
	return dispatch => {
		const token = getToken();
		console.log("checkToken")
		axiosInstance.put(
			"kalendarz/token.php",
			{ token: token}
			)
			.then(response => {
				let expirationTime = minutesUntilSessionExpire(response.data.status.token_czas);
				dispatch(openSessionExpirationSnackbar(expirationTime));
			})
	};
};

const openSessionExpirationSnackbar = (value) => {
	return {
		type: actionTypes.OPEN_SESSION_EXPIRATION_SNACKBAR,
		open: value <= 5,
		value: value
	};
};

export const closeSessionExpirationSnackbar = () => {
	return {
		type: actionTypes.OPEN_SESSION_EXPIRATION_SNACKBAR,
		open: false,
	};
};

export const renewSession = () => {
	return dispatch => {
		const token = getToken();
		post(
			dispatch,
			"kalendarz/token.php",
			{ token: token },
			response => {
				let expirationTime = minutesUntilSessionExpire(response.data.status.token_czas);
				dispatch(openSessionExpirationSnackbar(expirationTime));
			}
		)
	};
};

const minutesUntilSessionExpire = (expirationTime) => {
	let now = moment();
	return moment.unix(expirationTime).diff(now, 'minutes');
};